var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "risk-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "arrow-wrap", style: { bottom: _vm.bottomValue + "%" } },
      [
        _c("div", {
          staticClass: "line",
          style: { "background-color": "" + _vm.numColor }
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "value", style: { color: "" + _vm.numColor } },
          [_vm._v(_vm._s(_vm.value))]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "risk-bar" }, [
      _c("div", { staticClass: "section red" }),
      _vm._v(" "),
      _c("div", { staticClass: "section yellow" }),
      _vm._v(" "),
      _c("div", { staticClass: "section green" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed1dbfb6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed1dbfb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/history/index/components/AmlIndicatore.vue
// module id = Ek6X
// module chunks = 1